import { render, staticRenderFns } from "./GiftMessageWidget.vue?vue&type=template&id=a637c7ec"
import script from "./GiftMessageWidget.vue?vue&type=script&lang=js"
export * from "./GiftMessageWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports